import { useEffect, useRef, useState } from 'react';

const parse = value => Number(String(value).replace(',', '.'));
const format = value => value == null || value === '' ? '' : Number(value).toFixed(2).replace('.', ',');

export const ScanMoneyInput = ({ value, onChange, testId, id = testId, label, validationKey, onValidityChange,
  negative = false, className = '' }) => {
  const [draft, setDraft] = useState(format(value));
  const focused = useRef(false);
  const edited = useRef(false);
  const number = parse(draft);
  const valid = draft.trim() !== '' && Number.isFinite(number) && (negative ? number <= 0 : number >= 0);
  useEffect(() => { if (!focused.current) setDraft(format(value)); }, [value]);
  useEffect(() => { onValidityChange?.(validationKey, valid); }, [validationKey, valid, onValidityChange]);
  useEffect(() => () => onValidityChange?.(validationKey, true), [validationKey, onValidityChange]);
  return <>
    <input id={id} type="text" inputMode="decimal" placeholder="0,00" value={draft} aria-label={label} aria-invalid={!valid}
      onFocus={e => { focused.current = true; edited.current = false; e.target.select(); }}
      onChange={e => {
        const raw = e.target.value.replace(/^(-?)0+(?=\d)/, '$1');
        edited.current = true; setDraft(raw);
        const amount = parse(raw);
        if (raw.trim() && Number.isFinite(amount) && (negative ? amount <= 0 : amount >= 0)) onChange(amount);
      }} onBlur={() => {
        focused.current = false;
        if (!valid) return;
        if (edited.current) {
          const rounded = Math.round((number + Math.sign(number) * Number.EPSILON) * 100) / 100;
          onChange(rounded); setDraft(format(rounded));
        } else setDraft(format(value)); // Merely opening a rounded view must not alter a precise stored price.
      }} className={`field-input w-full !h-9 !py-1 !px-2 text-right text-sm ${className}`} data-testid={testId} />
    {!valid && (value != null || edited.current) && <span role="alert" className="block text-[11px] text-red-700 mt-1" data-testid={`${testId}-error`}>Vul een geldig bedrag in.</span>}
  </>;
};